import { MigrationDefinition } from './migration.types';

/**
 * Migration: V3 → V4
 *
 * Upgrade:
 * - type "6_Bohrpunkt" → "6_Tiefbohrung"
 *
 * Downgrade:
 * - type "6_Tiefbohrung" → "6_Bohrpunkt"
 *
 * Note: 7_Moorpunkt bleibt unverändert (keine Umbenennung)
 */
export const migrationV3ToV4: MigrationDefinition = {
  fromVersion: 3,
  toVersion: 4,

  upgrade(doc: any): any {
    if (doc.type === '6_Bohrpunkt') {
      doc.type = '6_Tiefbohrung';
    }

    doc.version = 4;
    return doc;
  },

  downgrade(doc: any): any {
    if (doc.type === '6_Tiefbohrung') {
      doc.type = '6_Bohrpunkt';
    }

    doc.version = 3;
    return doc;
  },

  dataLossWarnings: []
};
